export const isWsAvailable = (state) => state.auth.wsConnected;
export const isAuthenticated = (state) => state.auth.logged;
export const isAuthLoaded = (state) => state.auth.loaded;
export const isTech = (state) => state.auth.tech;
